import { Injectable, Inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import localForage = require("localforage");

import { SessionStorageService } from "./session-storage.service";
import { config } from "../../../../config/index";
import { ActionRequiredListServcie } from '../components/action-required/action-required.service';

@Injectable()
export class AuthResolver implements CanActivate {

    pageUserRole: any;
    followUpCommunicationRoutes = ['follow-up-communication', 'virtual-consultation-communications',
        'patient-referral-list', 'parent-ortho-follow-up-communication', 'patient-ortho-follow-up-communication',
        'recent-expired-quotes', 'non-start-follow-up'];

    constructor(
        private _router: Router,
        private _sessionStorageService: SessionStorageService,
        private _actionRequiredListServcie: ActionRequiredListServcie,
        @Inject('utilService') private utilService: any) {
            this.utilService.updateActionRequiredListPendingCount.subscribe(this.updateActionRequiredPendingCount);
        }

    updateActionRequiredPendingCount = (data: any) => {
        if (data.update) {
            if (this.pageUserRole?.role === 'COO Admin' || this.pageUserRole?.role === 'Location Manager') {
                this.getPendingCountCOO();
            } else if (this.pageUserRole?.role === 'TC') {
                this.getPendingCountTC();
            }
        }
    };

    /**
     * function to check if logged in. If not return to login page.
     * @returns Promise false if not logged In
     */
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        try {
            const isLoggedIn = sessionStorage.getItem('logined');
            const isToken = await this._sessionStorageService.readItem(config.storage_key);
            const userRole: any = await this._sessionStorageService.readItem(config.role);
            this.pageUserRole = userRole;
            const subscription: any = await this._sessionStorageService.readItem(config.package);
            const practiceCountryKey: any = await this._sessionStorageService.readItem('practice_country_key');

            // Checking token
            if (!isLoggedIn && !isToken && !userRole.role && !subscription.package) {
                this.utilService.hideChat.next({ hide: true });
                this._router.navigate(['login']);
                return false;
            }
            // Checking path wise authentication
            else {
                this.actionsBasedOnPath(route.routeConfig.path, userRole);

                // get Action Required List pending count
                if (userRole.subscription_status === 'active') {
                    if (userRole.role === 'COO Admin' || (userRole.role === 'Location Manager')) {
                        this.getPendingCountCOO();
                    } else if (userRole.role === 'TC') {
                        this.getPendingCountTC();
                    }
                }

                return this.pathWiseAuthentication(route, userRole, practiceCountryKey);
            }
        } catch (error) {
            if (window.location.href.indexOf('?patient_id=') != -1
                || window.location.href.indexOf('practice-profile') != -1) {
                localStorage.setItem('redirectUrlToLink', window.location.href);
            }
            this.utilService.hideChat.next({ hide: true });
            this._router.navigate(['logout']);
            return false;
        }
    }

    getPendingCountCOO() {
        this._actionRequiredListServcie.approvalListService(0, 0)
            .subscribe(res => {
                this.utilService.actionRequiredListPendingCount.next({ count: res.count });
            });
    }

    getPendingCountTC() {
        this._actionRequiredListServcie.followUpCommunicationService(0, 0, null, null)
            .subscribe(res => {
                this.utilService.actionRequiredListPendingCount.next({ count: res.count });
            });
    }

    subscriptionAccessAllowed(userRole: any, path: string) {
        if (userRole.subscription_status === 'expired' || userRole.pending_payment?.type === 'restrict'
            || (!userRole.subscription_status && path.indexOf('practice_contract_call_back') === -1)
            || (userRole.subscription_status === 'initial_pending' && path !== 'cart')
            || (userRole.subscription_status !== 'active' && path === 'cart-success')
            || (userRole.subscription_status === 'active' && !userRole.is_ses_email_verified && path !== 'cart-success')) {
            return false;
        }
        return true;
    }

    actionsBasedOnPath(targetRoute: any, userRole: any) {
        const url = this._router.url,
            chatAvailableRoles = ["TC", "COO Admin", "Location Manager"];

        if (url === "/patient/treatment-plan") {
            if (this._sessionStorageService.readItem('editPrevPlan')) {
                this._sessionStorageService.removeItem('editPrevPlan');
            }
            if (this._sessionStorageService.readItem('historyActionType')) {
                this._sessionStorageService.removeItem('historyActionType');
            }
        }

        if (url === "/user/user-list") {
            if (this._sessionStorageService.readItem('viewUserList')) {
                this._sessionStorageService.removeItem('viewUserList');
            }
        }

        let communicationRoute = this.followUpCommunicationRoutes.find((route: any) => targetRoute.indexOf(route) !== -1);
        if (!communicationRoute) {
            config.followUpSideBarOpen = true;
        }

        if (chatAvailableRoles.indexOf(userRole.role) !== -1) {
            this.utilService.hideChat.next({ hide: false });
        }
    }

    pathWiseAuthentication(route: any, userRole: any, practiceCountryKey: string) {
        const roles = route.data["roles"] as Array<string>;
        const path = route.routeConfig.path;

        if (roles === undefined || (userRole.role === 'Front Office' && path === 'patient-file-list')) {
            return true;
        } else {
            if (roles === null || roles.indexOf(userRole.role) === -1) {
                this.removeRedirectUrlLink();
                this._router.navigate(['home/dashboard']);
                return false;
            } else {
                return this.checkSubscriptionAccess(userRole, path, practiceCountryKey);
            }
        }
    }

    checkSubscriptionAccess(userRole: any, path: string, practiceCountryKey: string) {
        if (!this.subscriptionAccessAllowed(userRole, path) && userRole.role !== 'CT Admin') {
            this.removeRedirectUrlLink();
            let base_path = userRole.role === 'Front Office' ? 'patient/patient-file-list' : 'home/dashboard';
            this._router.navigate([base_path]);
            return false;
        } else {
            if (userRole.role === 'COO Admin' && path === 'vc-settings' && practiceCountryKey === 'AU') {
                this._router.navigate(['home/dashboard']);
                return false;
            } else {
                return true;
            }
        }
    }

    removeRedirectUrlLink() {
        if (localStorage.getItem('redirectUrlToLink')) {
            localStorage.removeItem('redirectUrlToLink');
        }
    }
}
